import ReactDOM from 'react-dom';
import {Route} from 'react-router';

import Login from './components/login/';
import Theme from './components/theme/';
import EM7Portal from './components/em7portal/';
import store from './stores/';
//import favStore from '../favourite/stores/';

import {WeaLicenseSubmit} from  'weaPortalPublic';

// 加载左侧菜单统计数
window.loadLeftMenuCount = (params, callback) => {
    store.portalThemeStore.onLoadLeftMenuCount(params, callback);
};
// 执行主题相关方法
window.doThemeAction = (actionName, params = {}, callback) => {
    if (actionName == 'onLoadMain') { // 加载内容区域
        store.portalThemeStore.onLoadMain(params);
    } else if (actionName == 'onLeftMenuModeChange') { // 展开收缩左侧菜单
        store.portalThemeStore.onLeftMenuModeChange(params.leftMenuMode, callback);
    } else if (actionName == 'onQuickSearch') { // 快捷搜索跳转
        store.portalThemeStore.onQuickSearch(params);
    } else if (actionName == 'onLoadEmailMenu') { // 加载邮件菜单
        store.portalThemeStore.onLoadEmailMenu(params);
    } else if (actionName == 'onThemeChange') { // 修改主题
        store.portalThemeStore.onThemeChange(params, callback);
    } else if (actionName == 'onThemeTsChange') { // 修改特色门户主题
        store.portalThemeStore.onThemeTsChange(params, callback);
    } else if (actionName == 'onColorChange') { // 修改主题颜色
        store.portalThemeStore.onColorChange(params, callback);
    } else if (actionName == 'onLayoutChange') { // 修改主题布局
        store.portalThemeStore.onLayoutChange(params, callback);
    } else if (actionName == 'getAccount') { // 刷新账号栏
        store.portalThemeStore.getAccount(params, callback);
    }
};

window.doLicenseSubmit = () => {
    const div = document.createElement('div');
    document.body.appendChild(div);
    ReactDOM.render(<WeaLicenseSubmit visible={true} from="login"/>, div);
};

const ThemeRoute = <Route path='main' component={Theme}/>;

module.exports = {Route: ThemeRoute, store: {...store}, Login, Theme, EM7Portal};



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/index.js